import React, { useContext } from 'react';
import { connect } from 'react-redux';

import { useBreakpoint } from '@americanexpress/aqx-components';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

import { makeGetSelectedCards } from '../redux';

import { CurrentPermutationContext } from '../index.js';

const Header = ({ selectedCards }) => {
  const { sm } = useBreakpoint();
  const { currentPermutations } = useContext(CurrentPermutationContext);

  const visibleCards = sm
    ? [
        selectedCards[currentPermutations[0] - 1],
        selectedCards[currentPermutations[1] - 1]
      ]
    : selectedCards;

  return sm ? (
    <MobileHeader selectedCards={visibleCards} />
  ) : (
    <DesktopHeader selectedCards={visibleCards} />
  );
};

const mapStateToProps = () => {
  const getSelectedCards = makeGetSelectedCards();
  return state => {
    return {
      selectedCards: getSelectedCards(state)
    };
  };
};
export default connect(mapStateToProps)(Header);
